export default __webpack_public_path__ + "static/icon_onefuse-ef641e90098462b7189d7e6463f611a0.svg";